import { queryClient } from "@/src/config/react-query";
import { BlocksUser } from "@/src/models/user.model";
import { getToken } from "@/src/services/api/auth.api";
import * as signalR from "@microsoft/signalr";
import { useEffect } from "react";
import { Platform } from "react-native";

export const useNotificationConnection = (user?: BlocksUser | null) => {
  useEffect(() => {
    let connection: signalR.HubConnection | null = null;

    const setup = async () => {
      const isWeb = Platform.OS === "web";
      const accessToken = await getToken();
      if ((!accessToken && !isWeb) || !user) return;

      connection = new signalR.HubConnectionBuilder()
        .withUrl(
          `${process.env.EXPO_PUBLIC_BLOCKS_BASE_URL}/communication/v1/NotificationHub?x-blocks-key=${process.env.EXPO_PUBLIC_X_BLOCKS_KEY}`,
          {
            ...(accessToken
              ? { accessTokenFactory: () => accessToken }
              : {}),
            withCredentials: true,
          },
        )
        .withAutomaticReconnect()
        .build();

      const handleNotification = () => {
        queryClient.invalidateQueries({ queryKey: ["notifications"] });
      };

      connection.on("groupJoinRequest", handleNotification);
      connection.on("AddedToGroup", handleNotification);
      connection.on("postLiked", handleNotification);
      connection.on("postComment", handleNotification);
      connection.on("eventInvite", handleNotification);
      connection.on("eventCreated", handleNotification);
      connection.on("postShared", handleNotification);
      connection.on("removeFromGroup", handleNotification);
      connection.on("birthdayWish", handleNotification);
      connection.on("wikiCreated", handleNotification);
      connection.on("wikiUpdated", handleNotification);
      connection.on("newsCreated", handleNotification);
      connection.on("newsUpdated", handleNotification);

      try {
        await connection.start();
        console.log("Notification hub connection success");
      } catch (e) {
        console.error("Notification hub connection failed", e);
      }
    };

    if (user) setup();

    return () => {
      connection?.stop();
    };
  }, [user?.itemId]);
};
